import { admin } from './PhpHandler.svelte'
import { getCookie } from './cookie'
import {
	storeActiveBlock,
	storeFinishedContent,
	storeData,
	storeRemainingStorage,
	storeUpdateSingle,
	storeLogo,
	storeFoods,
	storeDrinks,
	storeRooms,
	storeShop,
	storeContact,
	storeIsLinked,
	storeLinked,
} from './Store.svelte'

const sortBlocks = (a, b) => {
	if (a.indexOf('Block') > -1) {
		a = a.replace('Block ', '')
		b = b.replace('Block ', '')
		a = parseInt(a)
		b = parseInt(b)
		if (a > b) return 1
		else if (a < b) return -1
		else return 0
	}
}

const sortRooms = (a, b) => {
	if (a.indexOf('Room') > -1) {
		a = a.replace('Room ', '')
		b = b.replace('Room ', '')
		a = parseInt(a)
		b = parseInt(b)
		if (a > b) return 1
		else if (a < b) return -1
		else return 0
	}
}

//usubscribe function
const un_subscribe = (unsubscribe) => {
	unsubscribe.forEach((value) => {
		value
	})
}

const update_store_data = async (blockName, singleImageBlock, hasLogo, blockTitle, blockIntro, data) => {
	let configFile

	//get the config file from store data

	const stoData = storeData.subscribe((value) => {
		configFile = value
	})
	if (configFile) {
		configFile.blocks.forEach((block) => {
			if (block.blockName === blockName) {
				block.singleImageBlock = singleImageBlock
				block.hasLogo = hasLogo
				block.blockTitle = blockTitle
				block.content = data

				//gallery
				if (blockName === 'gallery') block.blockIntro = blockIntro
			}
		})

		storeData.set(configFile)
		un_subscribe([stoData])
	}
}

export async function get_mail_greetings() {
	const userID = getCookie('id')
	const user = await get_config_file(userID)
	return user.mail
}

export async function save_mail_salutation(status, mailGreeting, mailSignature) {
	const userID = getCookie('id')
	const salutation = await admin({
		cmd: 'set_mail_salutation',
		usrID: userID,
		greeting: mailGreeting,
		signature: mailSignature,
	})

	return salutation
}

export async function get_room_number() {
	const roomNumber = await admin({
		cmd: 'get_room_number',
	})

	return roomNumber
}

export function sort_order(blocks) {
	//array that holds block to update the layout order
	let orderArray = []
	let sortArray = []
	if (!blocks) return

	blocks.forEach((block) => {
		if (block.blockName !== 'logo') orderArray.push(block)
	})

	orderArray.forEach((block) => {
		sortArray[block.layoutOrder] = block
	})

	return sortArray
}

export function sort_blocks(list) {
	list.sort(sortBlocks)
	return list
}

export function sort_rooms(list) {
	let array = []
	if (list) {
		list.forEach((li) => {
			array[parseInt(li[0]) - 1] = li
		})
	}

	return array
}

export async function get_config_file() {
	const configFile = await admin({
		cmd: 'get_config_file',
	})

	return configFile
}

export async function new_content(blockName) {
	const ID = getCookie('id')
	let finishedBlocks = []
	let linkedPages = []

	const finishedContent = await get_finished_content()

	finishedBlocks = finishedContent.finishedBlocks
	linkedPages = finishedContent.linkedPages
	finishedBlocks.sort()
	const configFile = await get_config_file(ID)
	if (configFile) {
		storeData.set(configFile)
	}

	//add the "contact" to finishedBlocks
	if (configFile.widgets.indexOf('contact-form') > -1 && !finishedBlocks.includes('contact')) {
		finishedBlocks.push('contact')
		storeFinishedContent.set({ finishedBlocks: finishedBlocks, linkedPages: linkedPages })
	}

	//the new "Block" number
	let newBlockNumber = finishedBlocks.length + linkedPages.length

	//minus gallery and coverslider
	if (finishedBlocks.includes('gallery')) newBlockNumber--
	if (finishedBlocks.includes('cover-slider')) newBlockNumber--
	if (finishedBlocks.includes('logo')) newBlockNumber--
	if (finishedBlocks.includes('drinks')) newBlockNumber--
	if (finishedBlocks.includes('foods')) newBlockNumber--
	if (finishedBlocks.includes('rooms')) newBlockNumber--
	if (finishedBlocks.includes('shop')) newBlockNumber--
	if (finishedBlocks.includes('booking')) newBlockNumber--
	if (finishedBlocks.includes('mail')) newBlockNumber--
	if (!finishedBlocks.includes('contact')) newBlockNumber++

	if (finishedContent) {
		if (blockName === 'block') {
			const blockName = 'Block ' + newBlockNumber
			storeActiveBlock.set(blockName)
			return blockName
		}

		if (blockName === 'cover-slider') {
			if (finishedBlocks.includes('cover-slider')) {
				const blockName = 'cover-slider'
				storeActiveBlock.set(blockName)
				return blockName
			}
		}

		if (blockName === 'gallery') {
			const blockName = 'gallery'
			storeActiveBlock.set(blockName)
			return blockName
		}

		if (blockName === 'logo') {
			const blockName = 'logo'
			storeActiveBlock.set(blockName)
			return blockName
		}
	}
}

export async function get_finished_content() {
	let updateSingle
	const stoUpdateSingle = storeUpdateSingle.subscribe((value) => {
		updateSingle = value
	})

	un_subscribe([stoUpdateSingle])

	const finishedContent = await admin({
		cmd: 'get_finished_content',
	})

	finishedContent.finishedBlocks.sort()
	const finishedBlocks = sort_blocks(finishedContent.finishedBlocks)
	storeLinked.set(finishedContent.linkedPages)
	return { finishedBlocks: finishedBlocks, linkedPages: finishedContent.linkedPages }
}

export async function delete_content(blockName) {
	const response = await admin({
		cmd: 'delete_content',
		blockname: blockName,
	})

	const fileSize = await get_file_size()

	if (fileSize) {
		switch (blockName) {
			case 'logo':
				storeLogo.set(false)
				break
			case 'foods':
				storeFoods.set(false)
				break
			case 'drinks':
				storeDrinks.set(false)
				break
			case 'rooms':
				storeRooms.set(false)
				break
			case 'shop':
				storeShop.set(false)
				break
		}

		storeIsLinked.set(false)
		storeLinked.set(response.linkedPages)
		return response.finishedBlocks
	}
}

export async function get_block_content(blockName) {
	const userID = getCookie('id')
	let blockContent = null

	const configFile = await admin({
		cmd: 'get_config_file',
		id: userID,
	})

	configFile.blocks.forEach((item) => {
		if (item.blockName === blockName) {
			blockContent = item
		}
	})

	return [configFile.username, blockContent]
}

export async function update_config_file(blockName, singleImageBlock, hasLogo, isLinked, blockTitle, blockIntro, data) {
	//add the slider number to image-path the image object in data to number
	for (let i = 0; i < data.length; i++) {
		for (let key in data[i].image) {
			if (key === 'path') data[i].image = 'id' + (i + 1) + '_' + data[i].image.name
		}
	}
	let finishedContent
	const stoFinishedContent = storeFinishedContent.subscribe((value) => {
		finishedContent = value
	})

	//remove the block from finished blocks if it's already set
	finishedContent.finishedBlocks.forEach((item, index) => {
		if (item === blockName) finishedContent.finishedBlocks.splice(index, 1)
	})
	let newReload = [...finishedContent.finishedBlocks, blockName]
	newReload.sort()

	storeFinishedContent.set({ finishedBlocks: newReload, linkedPages: finishedContent.linkedPages })

	const updateConfig = await admin({
		cmd: 'update_config_file',
		block: blockName,
		singleImageBlock: singleImageBlock,
		hasLogo: hasLogo,
		isLinked: isLinked,
		blockTitle: blockTitle,
		blockIntro: blockIntro,
		data: data,
	})

	if (updateConfig) storeData.set(updateConfig.configFile)

	// update the store data if user is updating single block
	let updateSingle
	const stoUpdateSingle = storeUpdateSingle.subscribe((value) => {
		updateSingle = value
	})

	if (updateSingle) {
		update_store_data(blockName, singleImageBlock, hasLogo, blockTitle, blockIntro, data)
	}

	un_subscribe([stoFinishedContent, stoUpdateSingle])
	storeData.set(updateConfig.configFile)
}

export async function reorder_layout(block, direction) {
	const userID = getCookie('id')
	storeContact.set(false)
	const configFile = await admin({ cmd: 'reorder_layout', block: block, direction: direction })
	if (configFile) {
		return configFile
	}
}

export async function get_file_size() {
	const fileSize = await admin({
		cmd: 'get_file_size',
	})

	if (fileSize.filesize > -1) {
		const totalStorage = fileSize.totalStorage.toFixed(2)
		storeRemainingStorage.set(totalStorage)
		return totalStorage
	}
}

export async function get_username() {
	const user = await admin({ cmd: 'get_user' })
	return user.username
}

export const createLoadObserver = (handler) => {
	let waiting = 0

	const onload = (el) => {
		waiting++
		el.addEventListener('load', () => {
			waiting--
			if (waiting === 0) {
				handler()
			}
		})
	}

	return onload
}

export const create_navigation = (cmd) => {
	const createNavigation = admin({ cmd: 'create_navigation', action: cmd })
}

export const update_contact = (title, name, street, zip, city, country, phone, mail, map, lng, lat, label) => {
	const updateContact = admin({
		cmd: 'update_contact',
		title: title,
		name: name,
		street: street,
		zip: zip,
		city: city,
		country: country,
		phone: phone,
		mail: mail,
		map: map,
		lng: lng,
		lat: lat,
		label: label,
	})

	return updateContact
}

/**** GUEST HOUSE ****/
export async function get_room_details(room) {
	const roomDetails = await admin({ cmd: 'get_room_details', room: room })
	return roomDetails
}
